import * as React from "react"

import { AppAntSwitch } from "@components"
import {includeShippingPrice} from "@signals";


export default function CommonFiltersWithShippingSwitch({ ...props }) {
    return <AppAntSwitch
            checked={ includeShippingPrice.value }
            onChange={ (e) => { includeShippingPrice.value = e.target.checked } }
            trueText='Include Shipping Price'
            falseText='Exclude Shipping Price'
            {...props}
        />
}